var SentryClient = require("./modules/lib/integrations/SentryClient");
SentryClient.init()

import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import routes from './modules/routes';

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from 'redux-thunk'

import { rootReducer } from "./modules/lib/reducers/RootReducer";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

var store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(thunkMiddleware))
)

render((
	<Provider store={ store }>
		<BrowserRouter>
			{ routes }
		</BrowserRouter>
	</Provider>
	),
	document.getElementById('app')
);


// WEBPACK FOOTER //
// ./index.js